export default __webpack_public_path__ + "static/gs-4-copysnidbit-5bf8fe328eeb724926c0789fd97c9dd4.webp";